import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";

export const isServiceOrAdvisoryDomain = (
	domain: ClientPortfolioDomainEnum | undefined,
): boolean =>
	domain === ClientPortfolioDomainEnum.Services ||
	domain === ClientPortfolioDomainEnum.PaidAdvisory;
